


















import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Item extends Vue {
    @Prop({ default: 'label' }) label: string;
    @Prop({ default: false }) showCenter: boolean;
    @Prop() tab: string;
    @Prop() type: string;

    @Emit()
    center() {}

    get getLabel() {
        if (this.type) {
            return this.label + ' (' + this.type + ')';
        } else {
            return this.label;
        }
    }
}
